var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9996 24.6104L7.09412 36.5492C6.34147 37.2975 5.38354 37.6716 4.22034 37.6716C3.05715 37.6716 2.09922 37.2975 1.34657 36.5492C0.598271 35.8009 0.224121 34.8485 0.224121 33.692C0.224121 32.5356 0.598271 31.5832 1.34657 30.8349L13.2853 18.8961L1.34657 7.09286C0.598271 6.34014 0.224121 5.38218 0.224121 4.21898C0.224121 3.05572 0.598271 2.09776 1.34657 1.34511C2.09487 0.596806 3.04725 0.222656 4.20371 0.222656C5.36018 0.222656 6.31256 0.596806 7.06086 1.34511L18.9996 13.2839L30.8029 1.34511C31.5556 0.596806 32.5136 0.222656 33.6768 0.222656C34.84 0.222656 35.798 0.596806 36.5507 1.34511C37.367 2.16143 37.7751 3.13082 37.7751 4.25327C37.7751 5.37572 37.367 6.31109 36.5507 7.05939L24.6119 18.8961L36.5507 30.8016C37.299 31.5543 37.6731 32.5122 37.6731 33.6754C37.6731 34.8386 37.299 35.7965 36.5507 36.5492C35.7343 37.3655 34.7649 37.7737 33.6425 37.7737C32.52 37.7737 31.5847 37.3655 30.8364 36.5492L18.9996 24.6104Z",
    fill: "#FFBAB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.617f54911dbbd4e0ba71c741fc22b2f1.svg";
export { ForwardRef as ReactComponent };